import { useEffect, useState } from "react";
import { Grid, DataGrid, Tooltip, Checkbox } from "../../../../components";
import {
  ConversaoEntradaDialog,
  EditarProdutoDialog,
  VincularProdutoDialog,
} from "../dialogs";
import {
  CfopService,
  GrupoProdutosService,
  GruposTributarioService,
  UnidadeComercialService,
} from "../../../../services";
import { responseErros } from "../../../../utils";
import { value } from "../../../../helpers";
import {
  ActionsProdutosGridXml,
  GrupoProdutoTributarioXml,
} from "./components-steps";
import { erroCelulaGridProdutos } from "../../importar-xml";

const gruposTributarioService = new GruposTributarioService();
const grupoProdutosService = new GrupoProdutosService();
const unidadeComercialService = new UnidadeComercialService();
const cfopService = new CfopService();

const ProdutosXmlStep = ({
  produtos,
  setProdutos,
  setIsCadastro,
  inputErros,
}) => {
  const [openConverterEntradaDialog, setOpenConverterEntradaDialog] =
    useState(false);
  const [openVincularProdutoDialog, setOpenVincularProdutoDialog] =
    useState(false);
  const [openEditarProdutoDialog, setOpenEditarProdutoDialog] = useState(false);
  const [gruposTributarios, setGruposTributarios] = useState([]);
  const [gruposProdutos, setGruposProdutos] = useState([]);
  const [listaUnidadesComerciais, setListaUnidadesComerciais] = useState([]);
  const [listaCfop, setListaCfop] = useState([]);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [produtosConvertidos, setProdutosConvertidos] = useState([]);
  const colunasProdutos = [
    {
      field: "produto",
      headerName: "Produto",
      sortable: false,
      flex: 380,
    },
    {
      field: "ncm",
      headerName: "NCM",
      sortable: false,
      flex: 100,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.value || params.row?.ncmCodigo,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "cfop",
      headerName: "CFOP",
      sortable: false,
      flex: 90,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "grupoProdutoId",
      headerName: "Grupo Produto",
      sortable: false,
      flex: 200,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(gruposProdutos, params.value)?.descricao,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "grupoTributacaoId",
      headerName: "Grupo Tributário",
      sortable: false,
      flex: 250,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(gruposTributarios, params.value)?.nome,
      renderCell: (params) => renderCellTratamentoErros(params),
    },
    {
      field: "unidadeComercialVendaId",
      headerName: "Unid. Venda",
      sortable: false,
      flex: 150,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(listaUnidadesComerciais, params.value)?.descricao,
    },
    {
      field: "itemUsoConsumo",
      headerName: "Uso e Consumo",
      sortable: false,
      flex: 185,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        value.autoComplete(listaUnidadesComerciais, params.value)?.descricao,
      renderHeader: (params) => {
        return (
          <Tooltip
            title="Indica se o item é destinado a uso e consumo interno da empresa, e não para revenda."
            arrow
            placement="top"
          >
            <span className="MuiDataGrid-columnHeaderTitle">
              {params.colDef.headerName ?? params.colDef.field}
            </span>
          </Tooltip>
        );
      },
      renderCell: (params) => (
        <Checkbox
          disabled={params.row.produtoId || params.row.registrado}
          checked={params.row.usoConsumo}
          onChange={(event) => onClickCheckbox(event, params.row.id)}
        />
      ),
    },
    {
      field: "acoes",
      sortable: false,
      flex: 185,
      headerAlign: "center",
      disableClickEventBubbling: true,
      renderHeader: () => {
        return (
          <div>
            <i className="ph-fill ph-note-pencil" style={{ fontSize: 20 }}></i>
          </div>
        );
      },
      renderCell: (params) => (
        <ActionsProdutosGridXml
          params={params}
          handleOpenActions={handleOpenActions}
        />
      ),
    },
  ];

  const renderCellTratamentoErros = (params) => {
    return erroCelulaGridProdutos(params, inputErros) ? (
      <Tooltip
        title={`${params.colDef.headerName} é obrigatório`}
        arrow
        placement="top"
      >
        <i
          className="ph ph-warning"
          style={{ fontSize: 26, color: "#e53935" }}
        />
      </Tooltip>
    ) : (
      params.formattedValue
    );
  };

  const onClickCheckbox = (event, id) => {
    const produtosAtualizados = produtos.map((prod) =>
      prod.id === id ? { ...prod, usoConsumo: event.target.checked } : prod,
    );
    setProdutos(produtosAtualizados);
    const filtrarUsoConsumo = produtosAtualizados.filter(
      (item) => !item.usoConsumo,
    );
    if (filtrarUsoConsumo.length === 0) {
      setIsCadastro(false);
    } else {
      setIsCadastro(true);
    }
  };

  const handleOpenActions = (produto, tipo, produtoIndice) => {
    setProdutoSelecionado(produto);
    if (tipo === "CONVERTER") {
      if (produtoIndice !== null && produto?.produtoConvertido) {
        desfazerConversao(produtoIndice);
      }
      setOpenConverterEntradaDialog(true);
    }
    if (tipo === "VINCULAR") {
      setOpenVincularProdutoDialog(true);
    }
    if (tipo === "EDITAR") {
      setOpenEditarProdutoDialog(true);
    }
  };

  const desfazerConversao = (produtoIndice) => {
    const produtoConvertido = produtosConvertidos.find(
      (produto) => produto.produtoIndice === produtoIndice,
    );
    if (produtoConvertido) {
      const produtosXmlTemp = produtos.map((item, _index) => {
        if (_index === produtoIndice) {
          return produtoConvertido;
        } else {
          return item;
        }
      });
      setProdutos(produtosXmlTemp);
      setProdutosConvertidos(
        produtosConvertidos.filter(
          (produto) => produto.id !== produtoConvertido.id,
        ),
      );
    }
  };

  useEffect(() => {
    buscarGruposTributario();
    buscarGruposProdutos();
    buscarUnidadesComerciais();
  }, []);

  const buscarGruposTributario = () => {
    gruposTributarioService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data) {
            setGruposTributarios(result.data);
          }
        } else {
          responseErros(result);
        }
      });
  };

  const buscarGruposProdutos = () => {
    grupoProdutosService
      .getAll({
        ativado: true,
        nonPaginated: true,
      })
      .then((result) => {
        if (!result.isAxiosError) {
          setGruposProdutos(result.data);
        } else {
          responseErros(result);
        }
      });
  };

  const buscarCfops = async (codigo) => {
    const filtros = {
      codigo,
      nonPaginated: true,
    };
    if (codigo?.length) {
      const result = await cfopService.getAllAvancado(filtros);
      if (!result.isAxiosError) {
        setListaCfop(result.data);
      } else {
        responseErros(result);
      }
    }
  };

  const buscarUnidadesComerciais = () => {
    unidadeComercialService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setListaUnidadesComerciais(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  return (
    <>
      <GrupoProdutoTributarioXml
        listaCfop={listaCfop}
        buscarCfops={buscarCfops}
        gruposProdutos={gruposProdutos}
        gruposTributarios={gruposTributarios}
        listaUnidadesComerciais={listaUnidadesComerciais}
        setProdutos={setProdutos}
        inputErros={inputErros}
      />
      <Grid container spacing={2} sx={{ pl: 2, mt: 3 }}>
        <DataGrid
          rows={produtos || []}
          columns={colunasProdutos}
          rowCount={produtos?.length || 0}
          disableAcoes
        />
      </Grid>
      <ConversaoEntradaDialog
        produtos={produtos}
        setProdutos={setProdutos}
        produtoSelecionado={produtoSelecionado}
        setProdutoSelecionado={setProdutoSelecionado}
        openConverterEntradaDialog={openConverterEntradaDialog}
        setOpenConverterEntradaDialog={setOpenConverterEntradaDialog}
        setProdutosConvertidos={setProdutosConvertidos}
      />
      <VincularProdutoDialog
        produtos={produtos}
        setProdutos={setProdutos}
        produtoSelecionado={produtoSelecionado}
        openVincularProdutoDialog={openVincularProdutoDialog}
        setOpenVincularProdutoDialog={setOpenVincularProdutoDialog}
      />
      <EditarProdutoDialog
        produtos={produtos}
        setProdutos={setProdutos}
        produtoSelecionado={produtoSelecionado}
        setProdutoSelecionado={setProdutoSelecionado}
        gruposProdutos={gruposProdutos}
        setGruposProdutos={setGruposProdutos}
        listaCfop={listaCfop}
        setListaCfop={setListaCfop}
        buscarCfops={buscarCfops}
        gruposTributarios={gruposTributarios}
        listaUnidadesComerciais={listaUnidadesComerciais}
        openEditarProdutoDialog={openEditarProdutoDialog}
        setOpenEditarProdutoDialog={setOpenEditarProdutoDialog}
        inputErros={inputErros}
      />
    </>
  );
};

export default ProdutosXmlStep;
